// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconHardwareLowQuality_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.92554 18.0004V6.57639H4.97354V16.2724H9.74154V18.0004H2.92554ZM21.6179 12.2724C21.6179 13.5951 21.3672 14.7364 20.8659 15.6964 20.3752 16.6457 19.6232 17.3231 18.6099 17.7284L21.3619 20.7204H18.6419L16.5139 18.1604H16.2419C15.0152 18.1604 14.0072 17.9151 13.2179 17.4244 12.4286 16.9337 11.8366 16.2457 11.4419 15.3604 11.0579 14.4751 10.8659 13.4404 10.8659 12.2564 10.8659 11.0831 11.0579 10.0591 11.4419 9.18439 11.8366 8.29906 12.4286 7.61639 13.2179 7.13639 14.0179 6.64572 15.0312 6.40039 16.2579 6.40039 17.4632 6.40039 18.4606 6.64572 19.2499 7.13639 20.0499 7.61639 20.6419 8.29906 21.0259 9.18439 21.4206 10.0591 21.6179 11.0884 21.6179 12.2724ZM13.0259 12.2724C13.0259 13.5631 13.2819 14.5764 13.7939 15.3124 14.3166 16.0484 15.1326 16.4164 16.2419 16.4164 17.3832 16.4164 18.2046 16.0484 18.7059 15.3124 19.2072 14.5764 19.4579 13.5631 19.4579 12.2724 19.4579 10.9817 19.2072 9.96839 18.7059 9.23239 18.2046 8.49639 17.3886 8.12839 16.2579 8.12839 15.1379 8.12839 14.3166 8.49639 13.7939 9.23239 13.2819 9.96839 13.0259 10.9817 13.0259 12.2724Z" class="svg-bg"/>
</svg>
`;
/**
 * IconHardwareLowQuality is a generated icon component.
 */
let IconHardwareLowQuality = IconHardwareLowQuality_1 = class IconHardwareLowQuality extends IconBaseElement {
    render() {
        return html `${IconHardwareLowQuality_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconHardwareLowQuality.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconHardwareLowQuality = IconHardwareLowQuality_1 = __decorate([
    customElement('zui-icon-hardware-low-quality')
], IconHardwareLowQuality);
export { IconHardwareLowQuality };
